var components
try {
  components = {
    uSwipeAction: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-swipe-action/u-swipe-action" */ "uview-ui/components/u-swipe-action/u-swipe-action.vue"
      )
    },
    uSwipeActionItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-swipe-action-item/u-swipe-action-item" */ "uview-ui/components/u-swipe-action-item/u-swipe-action-item.vue"
      )
    },
    uNumberBox: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-number-box/u-number-box" */ "uview-ui/components/u-number-box/u-number-box.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }